import { roomOccupancy as e } from "./roomOccupancy.mjs";
//#region src/housekeeping/filterBoardRooms.ts
var t = (t, { status: n, occupancy: r, assigneeUserId: i, query: a }) => {
	let o = a?.trim().toLowerCase() ?? "";
	return t.filter((t) => (!n || t.hk.status === n) && (!r || e(t) === r) && (!i || t.hk.assignee_user_id === i) && (!o || (t.name ?? "").toLowerCase().includes(o)));
};
//#endregion
export { t as filterBoardRooms };
